export enum CalculationsState {
  STARTED = "started",
  PREPRARING = "preparing",
  CPM = "cpm",
  RACINGLINE = "RacingLine",
  FORCAST = "forcast",
  UPLOADDATA = "UploadData",
  DONE = "done",
}
